import { useCallback } from 'react';
import { useCrossTabEventsListener, sendCrossTabEvent, NameSpaces } from 'modules/EventsManager';
import { getPageType, PageTypes } from 'utils/pageTypes';
import { focusEvent, dispatchExtensionEvent } from 'domains/extension/extensionEventCreators';
import { useViewerId } from 'hooks/useViewerId';

export const useFocusManager = (): void => {
  const viewerId = useViewerId();

  useCrossTabEventsListener(NameSpaces.FOCUS_WINDOW, ({ payload }) => {
    const pageType = getPageType(window.location.href);
    if (payload.pageType === pageType) {
      if (pageType === PageTypes.VIEWER && payload.viewerId !== viewerId) {
        // wrong Viewer
        return;
      }
      dispatchExtensionEvent(focusEvent());
    }
  });
};
export type SendFocusEvent = (arg1: { pageType: PageTypes; viewerId?: string }) => void;

export const useSendFocusEvent = (): SendFocusEvent => {
  return useCallback(
    ({ pageType, viewerId }) => sendCrossTabEvent(NameSpaces.FOCUS_WINDOW, { pageType, viewerId }),
    []
  );
};
